// File generated by: MiFinanzas.Utils.Net.MiFinanzasPostBuildEvents
export enum OrderType {
	Collect = 1,
	Payment = 2,
}
